const URL_ID = {
  ABOUT: 'about',
  PRIVACY: 'privacy',
  TERMS: 'terms',
  COOKIE: 'cookie',
  PRICING: 'pricing',
  FAQ: 'faq',
  FEEDBACK: 'feedback',
  LINKEDIN: 'linkedin',
  FACEBOOK: 'facebook',
  TWITTER: 'twitter',
  INSTAGRAM: 'instagram',
  OFFERS: 'offers',
};

export default URL_ID;
